import React, { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { IMediumWithLinkId, IOneComponentHVideo } from "../../component";
import { SimpleBigVideo } from "../ComponentLiveShow/BigVideoWrapper";
import { IMedium } from "../../store/VideoStore";
import { inject, observer } from "mobx-react";
import RootStore from "../../store/RootStore";
import Player from "../VideoV2/Player";
import useVideoCore from "../ComponentLiveShow/useVideoCore";
import { createPortal } from "react-dom";
import NoticeQrcode from "../NoticeQrcode";
import { shouldShowNotice } from "../ComponentVideoH/AllForVideoH";
interface IType2CurrentPlay {
  // list: IOneComponentHVideo[];
  // currentIndex: number;
  info: IMediumWithLinkId;
  setIndex: Dispatch<SetStateAction<number>>;
  rootStore?: RootStore;
}
function Type2CurrentPlay(props: IType2CurrentPlay) {
  const { info, rootStore, setIndex } = props;
  // todo: 先强制写死了是h模式
  const { onCreated, bigVideoWrapper, size } = useVideoCore({
    list: [info],
    index: 0,
    mode: "h",
    forceNoAutoPlay: true,
  });

  console.log(info, "info");

  const one = info;

  return createPortal(
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <div className="bigpic-operation">
        <img
          src={require("../../assets/x-circle.png")}
          alt=""
          className="bigpic-close position-type2-curren-l=play"
          onClick={() => {
            setIndex(-1);
          }}
        />
      </div>
      <div
        className="video-calc-useless"
        style={{ ...size, position: "relative" }}
      >
        <Player
          key={one.id}
          source={one}
          width={`100%`}
          height={`100%`}
          autoPlay={false}
          danmuku={false}
          rootStore={rootStore}
          targetId={`bigvideo_${one.id}`}
          onCreated={onCreated}
        />
        {shouldShowNotice(true, one) ? (
          <NoticeQrcode videoid={Number(one.id)} />
        ) : null}
      </div>
    </div>,
    bigVideoWrapper
  );
}

export default inject("rootStore")(observer(Type2CurrentPlay));
